import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import AgeGroup from "src/components/panel/education_programs/age-groups/AgeGroups";

const EducationAgeGroupsView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("education_age_groups_list_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("education_age_groups_list_title")}
          subtitle={t("education_age_groups_list_subtitle")}
        />
        <AgeGroup />
      </Sidebar>
    </>
  );
};

export default EducationAgeGroupsView;
